import { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "./AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, authLoading } = useContext(AuthContext);
  if (authLoading) {
    return (
      <div className="h-screen flex flex-col items-center justify-center gap-4 bg-gray-100 dark:bg-slate-950">
        <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Checking authentication...
        </p>
      </div>
    );
  }
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;